<div class="dialog-container">
  <div class="header">
    <img class="photo" [src]="organization.photo" alt="Foto da Organização" />
    <div class="title-section">
      <h2>{{ organization.name }}</h2>
      <p class="subtitle">{{ organization.alias }}</p>
    </div>
  </div>

  <div class="section">
    <h3>Representante Legal</h3>
    <p>{{ organization.legal_representative }}</p>
  </div>

  <div class="section">
    <h3>CNPJ</h3>
    <p>{{ getCNPJ() }}</p>
  </div>

  <div class="section">
    <h3>Especialidade</h3>
    <p>{{ organizationLocation.speciality }}</p>
  </div>

  <div class="section">
    <h3>Endereço</h3>
    <p>
      {{ organizationLocation.street }}, {{ organizationLocation.number }}
      <span *ngIf="organizationLocation.complement"> - {{ organizationLocation.complement }}</span
      ><br />
      {{ organizationLocation.city }} - {{ organizationLocation.state }}, {{ organizationLocation.country }}<br />
      CEP: {{ organizationLocation.cep }}
    </p>
  </div>

  <div class="section">
    <h3>Contato</h3>
    <p *ngIf="organizationLocation.phone"><strong>Telefone:</strong> {{ organizationLocation.phone }}</p>
    <p *ngIf="organizationLocation.mobile"><strong>Celular:</strong> {{ organizationLocation.mobile }}</p>
    <p *ngIf="organizationLocation.mail"><strong>Email:</strong> {{ organizationLocation.mail }}</p>
  </div>

  <div class="footer-actions">
    <button mat-button color="primary" (click)="onClose()">Fechar</button>
  </div>
</div>
